import { useEffect, useState } from "react";
import { Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { api } from "@/lib/api";

let cache = null;
let pedido = null;
const cargar = () => {
  if (!pedido) pedido = api.get("/portal/glosario").then((r) => { cache = r.data; return cache; }).catch(() => { pedido = null; return {}; });
  return pedido;
};

export function useGlosario() {
  const [g, setG] = useState(cache);
  useEffect(() => { if (!cache) cargar().then(setG); }, []);
  return g || {};
}

/** Ícono ⓘ con la leyenda del término (glosario único del backend). Funciona con tap en celular. */
export function Ayuda({ k, className = "" }) {
  const g = useGlosario()[k];
  if (!g) return null;
  return <Popover modal>
    <PopoverTrigger asChild>
      <button type="button" onClick={(e) => e.stopPropagation()} aria-label={`¿Qué es ${g.t}?`} className={`pointer-events-auto inline-flex align-middle ml-0.5 p-1 -m-0.5 text-[#5f6f66] hover:text-[#1f7a4d] ${className}`} data-testid={`ayuda-${k}`}>
        <Info className="w-3.5 h-3.5" />
      </button>
    </PopoverTrigger>
    <PopoverContent side="top" className="z-[3000] w-64 p-3 text-xs leading-snug normal-case tracking-normal font-normal" data-testid={`ayuda-texto-${k}`} onClick={(e) => e.stopPropagation()}>
      <p className="font-semibold text-[#124a2f] mb-1">{g.t}</p><p className="text-slate-700">{g.d}</p>
    </PopoverContent>
  </Popover>;
}
